import { Translate } from 'react-redux-i18n'

export const FirstThRow = ({ fsType, columns }) => {
  const getCols = () => {
    const result = []
    columns.forEach((col, colIndex) => {
      const isName = col.colId.startsWith('RatioName')
      const isPrevName = columns[colIndex - 1]?.colId?.startsWith('RatioName')
      if (isName) {
        result.push({ colSpan: 1, isValueCol: false })
      } else if (isPrevName) {
        result.push({ colSpan: 1, isValueCol: true })
      } else {
        result[result.length - 1].colSpan += 1
      }
    })
    return result
  }

  return (
    <tr>
      {getCols().map((col, colIndex) => {
        return (
          <th
            key={colIndex}
            colSpan={col.colSpan}
            style={{
              borderStyle: col.isValueCol ? 'solid' : '',
              borderWidth: '0px 0px 1px 0px',
              borderColor: '#3a414b',
              textAlign: 'center',
              fontWeight: 600,
              fontStyle: 'italic',
              padding: '2px 12px',
              whiteSpace: 'nowrap',
            }}
          >
            {col.isValueCol && (
              <Translate
                value={`financialStatement.dynamicTable.${
                  fsType === 'balanceSheets' ? 'AS_AT' : 'FOR_THE_YEAR_ENDED'
                }`}
              />
            )}
          </th>
        )
      })}
    </tr>
  )
}
